module.exports = __webpack_public_path__ + "static/media/guide1.d6fd238f.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/guide1.png
// module id = 389
// module chunks = 0